// extracted by mini-css-extract-plugin
var _1 = "UqcrF";
var _2 = "zMWwe";
var _3 = "SktDo";
var _4 = "Lf7TC";
export { _1 as "imageContainer", _2 as "imageGalleryWidth", _3 as "mediaCardHeight", _4 as "videoCardMaxHeight" }
